import { AnimatePresence, motion } from "framer-motion";
import { RxCross1 } from "react-icons/rx";

import { useModal } from "~/providers/ModalProvider";

export const ContentModal = ({ children }: { children: any }) => {
  const { closeModal } = useModal();
  return (
    <>
      <div className="mx-auto h-full w-full animate-in fade-in">
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="h-full w-full"
          >
            <div className="flex h-full flex-col items-center justify-center p-6">
              <RxCross1
                size={32}
                className="absolute right-10 top-10 cursor-pointer text-white"
                onClick={() => closeModal()}
              />
              {children}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
};
